import { Component, OnInit } from '@angular/core';
import { AuthService, FormErrors, Credentials } from "./auth.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginPage implements OnInit {

  public credentials: Credentials = new Credentials
  public errors: FormErrors = new FormErrors

  constructor(private authService: AuthService, private router: Router) { 
  }

  ngOnInit() {
  }

  public login(){
    this.errors.clear();
    this.authService.login(this.credentials).then(auth =>{
      let route = 'dashboard';

      if (auth.isManager()) {
        route = 'admin/approval';
      } else if (auth.isMaintainer()) {
         route = 'admin/devices';
      } else if (auth.isAdmin()) {
        route = 'admin';
      } else if (auth.isFirstLogin()) {
        route = 'upload';
      }
      this.router.navigate([route]);
    }, err => {
      this.errors.list  = err.json().errors;
    });
  }

  
  public showPassword(){

    var a = <HTMLInputElement>document.getElementById("inputPassword");
    var b = <HTMLInputElement>document.getElementById("passwordShowButton");

    if (a.type == "password") {
      a.type = "text";
      b.innerText = "Hide";
    } else {
      a.type = "password";
      b.innerText = "Show";
    }

  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/login/login.component.ts